// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTerritories} from '../../../user/shared/repositories/territories';

export const readTerritories = racfId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const territories = await getTerritories(racfId);

            dispatch({
                territories,
                type: actions.READ_AUDIT_SUMMARY_TERRITORIES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/audit-summary/action-creators/read-territories.js